import moment from "moment";
import { useEffect, useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../api/Get";
import { GET_CITAS_BY_MONTH } from "../api/Routes";
import bgHome from '../img/bgHome.png'
import { formatNumber } from "../utils/formatNumber";
import ComponentModalErrorSever from "./ComponentModalErrorSever";

function DashboardJefeDoctor({t, auth}){
    const [citas, setCitas] = useState(null)
    const [loading, setLoading] = useState(true)  
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)  

    useEffect(()=>{
        let mounted = true;
        Get({url: `${GET_CITAS_BY_MONTH}/${moment().format("DD-MM-YYYY")}`, access_token: auth.data.access_token})
        .then(response=>{
            if(mounted){
                setCitas(response.data.data.response)
                setLoading(false)
            }            
        })
        .catch(error => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        return () => mounted = false;
    }, [])

    return (
        <Container fluid>
            <Row>
                <Col xs="12" md="6" className="px-0" >   
                    <div className="bg-info-1">
                        <div className="p-5">
                            <h3 className="text-white">Ahorre tiempo en la gestión de su consultorio</h3>
                            <p className="text-white my-4">La herramienta definitiva para la gestión de las visitas y la comunicación con sus pacientes. Ahora, también, con servicio de consultas en línea por videollamada.
                            </p>
                        </div>
                    </div>                    
                        
                    <Row className="mt-3">
                        <Col><h5 className="m-3 text-primary1">Resultados del mes</h5></Col>
                    </Row>
                    <Row>
                        <Col xs="12" md="6">
                            <Card className="m-3">
                                <Card.Body>
                                    <label className="mb-0 text-secondary d-block">Citas generadas</label>
                                    <span className="text-color-1 font-size-17rem font-weight-bold">
                                        {
                                            loading ? 
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div> :
                                            formatNumber(Object.keys(citas).reduce((sum,key)=>sum+parseFloat(citas[key]||0),0))
                                        }                                            
                                    </span>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs="12" md="6">
                            <Card className="m-3">
                                <Card.Body>
                                    <label className="mb-0 text-secondary d-block">Citas canceladas</label>
                                    <span className="font-size-17rem font-weight-bold text-color-2">
                                        {   
                                            loading ? 
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div> :
                                            formatNumber(citas.Cancelada)
                                        }
                                    </span>
                                </Card.Body>
                            </Card>
                        </Col>                            
                    </Row> 
                </Col>
                <Col xs="12" md="6" className="d-md-block d-none px-0">
                    <Image src={bgHome} fluid />
                </Col>
            </Row>
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </Container>
    )

}

export default withTranslation()(DashboardJefeDoctor)